import React from "react";
import styled from "styled-components";
import { colorSelector } from "../../utils/ColorSelector";
import { GenericListProps as Props, SUBLIST_INDENTATION_INCREMENT_AMOUNT } from "../../types/GenericListType";
import { Flex } from "../Flex";
import { NestedList } from "../NestedList";
import { Span } from "../Span";

const OL = styled.ol`
  list-style: none;
  padding-inline-start: 0px;
  counter-reset: item;
`;

const LI = styled(Flex)`
  &::before {
    content: counter(item) ". ";
    counter-increment: item;
    font-weight: bold;
    color: ${colorSelector("secondary")};
  }
`;

export const OrderedList: React.FC<Props> = ({ content, indentationLevel }) => {
  const definedIndentationLevel = indentationLevel || 0;
  return (
    <OL>
      {content.map(contentItem => {
        return typeof contentItem === "string" ? (
          <LI as="li" alignItems="flex-start" lineHeight="body" fontSize={2} key={contentItem} paddingLeft={definedIndentationLevel}>
            <Span ml={2} dangerouslySetInnerHTML={{ __html: contentItem }} />
          </LI>
        ) : (
          <NestedList
            key={contentItem.content.toString()}
            childListContentItem={contentItem}
            indentationLevel={definedIndentationLevel + SUBLIST_INDENTATION_INCREMENT_AMOUNT}
          />
        );
      })}
    </OL>
  );
};
